export const SET_ADMIN = 'SET_ADMIN';
export const SET_COMPANY = 'SET_COMPANY';
export const SET_AUTH = 'SET_AUTH';
export const SET_ORIGIN = 'SET_ORIGIN';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_LOADING = 'SET_LOADING';
export const SET_PROCESSING = 'SET_PROCESSING';
export const SET_IS_POLLING_APPROVE_NFT_STATUS = 'SET_IS_POLLING_APPROVE_NFT_STATUS';
export const SET_IS_POLLING_STAKE_STATUS = 'SET_IS_POLLING_STAKE_STATUS';